import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseListComponent } from './components/case-list/case-list.component';
import { CaseFormComponent } from './components/case-form/case-form.component';

const routes: Routes = [
  { path: '', component: CaseListComponent },
  { path: 'create', component: CaseFormComponent },
  { path: 'edit/:id', component: CaseFormComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CasesRoutingModule { }
